import { apiClient } from "../api";
import { Landing, UpdateLandingDto } from "../generated/client";

export const upsertLanding = async (data: UpdateLandingDto): Promise<Landing> => {
    try {
        const response = await apiClient.landing.upsert(data);
        alert("Landing saved successfully");
        return response.data;
    } catch (error) {
        console.error("upsert landing:", error);
        throw error;
    }
};

export const getLanding = async (): Promise<Landing> => {
    try {
        const response = await apiClient.landing.find();
        return response.data;
    } catch (error) {
        console.error("fetch landing:", error);
        throw error;
    }
};
